import styled from 'styled-components'
import { theme } from '../theme';

export const Spacing = styled.div`
    padding-top: ${theme.spacingContent};
`